import { Cookies } from "react-cookie"
import Axios from 'axios'

export const requestBeacon = async (path, data) => {

    const cookies = new Cookies()
    const token = cookies.get('token')
    const tmp = cookies.get('tmp')
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': token,
        'tmp': tmp
    }
    const res = await Axios.post(`${process.env.REACT_APP_BEACON_API}/management/${path}`, data, {headers: headers})
    return res
}

export const requestBev = async (data) => {

    const cookies = new Cookies()
    const token = cookies.get('token')
    const tmp = cookies.get('tmp')
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': token,
        'tmp': tmp
    }
    const res = await Axios.post(`${process.env.REACT_APP_BEV_API2_URL}`, data, {headers: headers})
    return res
//     return new Promise( (resolve, reject) => {
//         Axios({
//             method: 'POST',
//             url: `${process.env.REACT_APP_BEV_API2_URL}`,
//             headers: headers,
//             // url:'https://beverestlifeapiuat.thaibevapp.com/work/v3/portal-management',
//             data: data
//         }).then(function (response) {
//             // console.log(response)
//             if(response.status === 200){
//                 resolve(response.data)
//             }else if(response.status === 401){      
//                 reject(response)
//             }else{
//                 return reject(Error(response.data.msg))
//             }
//         }).catch(function (error) {
//             reject(error)
//             console.log(error.response)           
//         })
//     })
}

export const requestRole = (method, path, data) => {
    //const params = data
    
    const cookies = new Cookies()
    const token = cookies.get('token')
    const tmp = cookies.get('tmp')
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': token,
        'tmp': tmp
    }

    return new Promise( (resolve, reject) => {
        Axios({
            method: method,
            url: `${process.env.REACT_APP_API_URL}${path}`,
            // url:'https://beverestlifeapiuat.thaibevapp.com/work/v3/portal-management',
            headers: headers,
            data: data
        }).then(function (response) {
            // console.log(response)
            if(response.status === 200){
                resolve(response.data)
            }else if(response.status === 401){      
                reject(response)
            }else{
                return reject(Error(response.data.msg))
            }
        }).catch(function (error) {
            reject(error)
            console.log(error.response)           
        })
    })
}
export const authSign =async()=>{
    const data = {
        "work":"AUTH.SIGN",
        "key": "SY5ir9yPLShPQ7eS8OPMNtin68yB8mUJnFdXprBfSMcnDaezeQJvPcOYkj6F0VSEhohYlSyE7dR2ruoXdMgi8RxWPbXSiS2eldH3"
    }
    const res = await Axios.post(`${process.env.REACT_APP_BEV_AUTH_API}`, data)
    // console.log(res)
    if(res.data.status === true){
        const cookies = new Cookies()
        cookies.set("token", res.data.result.token)
        cookies.set("tmp", res.data.result.tmp)
    }
    return res
    // return new Promise( (resolve, reject) => {
    //     Axios({
    //         method: 'post',
    //         url: `${process.env.REACT_APP_BEV_AUTH_API}`,
    //         // url:'https://beverestlifeapiuat.thaibevapp.com/work/v3/portal-management',
    //         data: data
    //     }).then(function (response) {
    //         // console.log(response)
    //         if(response.status === 200){
    //             resolve(response.data)
    //         }else if(response.status === 401){      
    //             reject(response)
    //         }else{
    //             return reject(Error(response.data.msg))
    //         }
    //     }).catch(function (error) {
    //         reject(error)
    //         console.log(error.response)           
    //     })
    // })

    // return requestBev(data).then( res=>{
        // if(res.status === true){
        //     const cookies = new Cookies()
        //     cookies.set("token", res.result.token)
        //     cookies.set("tmp", res.result.tmp)
        // }
    //     return res
    // }).catch(err=>{
    //     return err
    // })
}
export const reqSerchUserByText =(data)=>{
    return requestBev(data).then( res=>{
        return res
    }).catch(err=>{
        return err
    })
}

// export const createRole =(data)=>{
//     return requestRole(Method.POST, ServicePath.RoleCreate,data).then( res=>{
//         return res
//     }).catch(err=>{
//         return err
//     })
// }


// export const listNoti =()=>{
//     const data = {
//         "work": "FEED_NOTIFICATION",
//         "item_per_request": 20,
//         "current_item_amount":0
//      }
     
//     return requestNoti(data).then( res=>{
//         return res
//     }).catch(err=>{
//         return err
//     })
// }

// export const listDrawer =()=>{
//     const data = {
//         "work": "DRAWER_NOTIFICATION.FEED",
//         "item_per_request": 20,
//         "current_item_amount":0
//      }
     
//     return requestNoti(data).then( res=>{
//         return res
//     }).catch(err=>{
//         return err
//     })
// }

// export const displayTypes =()=>{
//     const data = {
//         "work": "DRAWER_NOTIFICATION.GET_CREATION_TEMPLATE"
//      }
     
//     return requestNoti(data).then( res=>{
//         return res
//     }).catch(err=>{
//         return err
//     })
// }
// export const upload=(data)=>{
//     try {
//         const res = Axios.post('http://thana.xyz:4001/work', data, {
//             headers: {
//                 'Content-Type': 'application/json'
//             }
//         })
//         return res
//     } catch (err) {
//         console.log(err)
//     }
// }

// export const logSendNoti =(data)=>{
//     return logRequest('POST', ServicePath.LogSendNoti, data).then( res=>{
//         console.log(res)
//         return res
//     }).catch(err=>{
//         console.log(err)
//         return err
//     })
// }